import { makeStyles, Typography, Grid, Box } from '@material-ui/core';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { selectBreadcrumbs, navigateToRoute } from '../../redux_store';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 32,
    paddingLeft: 28,
    padding: theme.spacing(3, 0),
    borderTopRightRadius: theme.shape.borderRadius,
    borderTopLeftRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
  },
  text: {
    fontSize: 14,
    color: theme.colors.gray4,
  },
  linkContainer: {
    position: 'relative',
  },
  link: {
    cursor: 'pointer',
    marginRight: theme.spacing(2.5),
    color: theme.colors.lightBlue,
  },
  currentTitle: {
    fontSize: 14,
    fontWeight: '400',
    color: theme.colors.gray4,
  },
  point: {
    top: 9,
    right: 8,
    width: 4,
    height: 4,
    borderRadius: '50%',
    position: 'absolute',
    backgroundColor: theme.colors.gray5,
  },
  content: {
    paddingRight: theme.spacing(3),
    transition: '0.3s',
  },
  contentSmallPadding: {
    paddingRight: theme.spacing(.8),
    transition: '0.3s',
  },
}));

const Breadcrumbs = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const breadcrumbs = useSelector(selectBreadcrumbs) || [];
  const { currentPage } = useSelector((state) => state.infoPane);
  const updatedBreadcrumbs =
    breadcrumbs.length > 1
      ? breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return isLast
            ? item
            : item.title === breadcrumbs[index + 1].title
            ? null
            : item;
        })
      : breadcrumbs;

  const handleLinkClick = (item) => {
    dispatch(navigateToRoute({
      route: {
        ...item,
      }
    }));
  };

  return (
    <Box className={cx(classes.content, {
      [classes.contentSmallPadding]: currentPage?.uuid
    })}>
      <Grid container alignItems="center" className={classes.root}>
        {updatedBreadcrumbs.map((item, index) => {
          const isLast = index === updatedBreadcrumbs.length - 1;
          if (item) {
            return isLast ? (
              <Typography
                key={item.path}
                className={cx(classes.text, classes.currentTitle)}
              >
                {item.title}
              </Typography>
            ) : (
              <div key={item.path} className={classes.linkContainer}>
                <Typography
                  onClick={() => handleLinkClick(item)}
                  className={cx(classes.text, classes.link)}
                >
                  {item.title}
                </Typography>
                <span className={classes.point} />
              </div>
            );
          }
        })}
      </Grid>
    </Box>
  );
};

export default Breadcrumbs;
